<div class="empty-state">
  <p>{{ message() }}</p>
</div>
